import React from 'react'
import { connect as connectRedux } from 'react-redux'
import compose from 'recompose/compose'
import { connect as connectStaticText } from '../StaticText/connect'
import { JOIN_NOW_URL, JOIN_NOW_QUERY } from '../../services/live-access-events/constants'
import Button, { TYPES } from '../Button/index'
import { H1, HEADING_TYPES } from '../Heading/index'

class PreviewDone extends React.Component {
  render () {
    const { props } = this
    const {
      staticText, auth, line1, line2, onClickUpgrade, joinUrl, joinQuery,
    } = props
    const subscriptions = auth.getIn(['subscriptions'])
    const isEntitled = subscriptions && !!subscriptions.size

    return (
      <div className="preview-done">
        <div>
          <H1 inverted as={HEADING_TYPES.H4} className="preview-done__label1">
            {line1 || staticText.getIn(['data', 'previewDoneLabel1'])}
          </H1>
          <div className="preview-done__label2">
            {line2 || staticText.getIn(['data', 'previewDoneLabel2'])}
          </div>
          {isEntitled
            ? <Button
              type={TYPES.PRIMARY}
              onClick={
                () => (onClickUpgrade())
              }
            >
              {staticText.getIn(['data', 'upgradeNow']) }
            </Button>
            : <Button
              type={TYPES.PRIMARY}
              url={joinUrl != null ? joinUrl : JOIN_NOW_URL}
              query={joinUrl != null ? joinQuery : JOIN_NOW_QUERY}
            >
              {staticText.getIn(['data', 'joinNow'])}
            </Button>
          }
        </div>
      </div>
    )
  }
}

export default compose(
  connectStaticText({ storeKey: 'livePage' }),
  connectRedux(
    (state) => ({
      auth: state.auth,
    }),
  ),
)(PreviewDone)
